export default {
    login_page_title: 'Cloud Login Page',
    login_page_language: 'Language',
    login_page_english: 'English',
    login_page_spanish: 'Spanish',
    login_page_templates: 'Templates',
    login_page_save: 'Save Cloud Login Page',
    login_page_preview: 'Preview',
    login_page_placeholder: 'Write page content here',
    login_page_create_message: 'Content saved',
    login_page_preview_message: 'Preview saved',
    login_page_select: 'Select',
    login_page_insert_image: 'Insert Image',
    login_page_create_edit_template: 'Create/Edit Template',
}